import { render, staticRenderFns } from "./EmailTemplateTypes.vue?vue&type=template&id=e1ff54fa&scoped=true"
import script from "./EmailTemplateTypes.vue?vue&type=script&lang=js"
export * from "./EmailTemplateTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ff54fa",
  null
  
)

export default component.exports